import React from "react";
export default (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon",
    viewBox: "0 0 37 30",
    style: {
      height: "1em",
      width: "1.23333em"
    }
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    transform: "translate(7.01 4.12)"
  }, React.createElement("path", {
    d: "M12.21875,0.6875 C8.56685645,0.682463399 5.19961248,2.57302485 3.42393058,5.62540966 C1.64824868,8.67779448 1.74372075,12.4113861 3.67329167,15.3770833 L0.71875,21.3125 L6.923,18.4855 C10.5513625,20.6441872 15.2093627,20.3755655 18.5403018,17.8155432 C21.871241,15.2555209 23.1486354,10.9624434 21.7261918,7.10837794 C20.3037483,3.25431251 16.4917043,0.67983776 12.21875,0.6875 Z"
  }), React.createElement("path", {
    d: "M14.375 14.4375L13.65625 14.4375C12.8623407 14.4375 12.21875 13.8218915 12.21875 13.0625L12.21875 9.625C12.21875 9.24530423 11.8969547 8.9375 11.5 8.9375L10.78125 8.9375M12.21875 5.84375C12.21875 5.65390212 12.0578523 5.5 11.859375 5.5"
  }), React.createElement("path", {
    d: "M11.859375,5.5 C11.6608977,5.5 11.5,5.65390212 11.5,5.84375 C11.5,6.03359788 11.6608977,6.1875 11.859375,6.1875 C12.0578523,6.1875 12.21875,6.03359788 12.21875,5.84375"
  }))));
});